import React from 'react';
import { useField } from 'formik';
import isEmpty from 'lodash/isEmpty';
import classNames from 'classnames';
import styles from './styles.scss';
import Translation from '../../../../../components/stateless/Translation';

const CheckoutFormDropdown = ({
  label,
  name,
  options,
  emptyOption,
  required,
  className,
  errorClassName,
  invalidClassName,
  validate,
}) => {
  const [field, meta] = useField({ name, validate });
  const error = meta.touched && !isEmpty(meta.error);

  const containerClasses = classNames(
    styles.checkoutFormDropdown,
    error && styles.error,
    error && invalidClassName,
    className,
  );

  return (
    <div className={containerClasses}>
      <div className={styles.label}>
        <div className={styles.text}>
          <Translation {...label} />
        </div>
      </div>
      <select
        {...field}
        required={required}
        className={classNames('form-control', error && styles.invalid)}
      >
        {emptyOption && (
          typeof emptyOption === 'string' ? (
            <option value="">{emptyOption}</option>
          ) : (
            <Translation {...emptyOption}>
              {text => <option value="">{text}</option>}
            </Translation>
          )
        )}
        {Object.entries(options).map(([value, optionLabel]) => (
          <option key={value} value={value}>{optionLabel}</option>
        ))}
      </select>
      {error && (
        <div className={classNames(styles.message, errorClassName)} role="alert">
          <Translation defaultMessage="Field is invalid" id={meta.error} />
        </div>
      )}
    </div>
  );
};

export default CheckoutFormDropdown;
